import { createContext } from "react";

import { ISessionContextValue } from "./session.models";

/**
 * The session itself lives in React state; `useRestoredSession` rebuilds it
 * from `localStorage` on mount when a persisted key session is there and
 * still valid, and signs the user back in with no re-prompt. See
 * ai/docs/kep-signing.md for what that trades away.
 */
export const SessionContext = createContext<ISessionContextValue | null>(null);
